export default __webpack_public_path__ + "static/media/G0750.Trachy_and_Lary_2.18.1666267500000.28d1a382.jpg";